import menuList from '@/views/menu';
import axios from '../utils/request.js';

let secondChild = [];

let getChildList = function (limit, obj) {
  let listLength;
  let childList = obj.newChildren.filter(itemChild => {
    let codeList = [];
    if (itemChild.code) {
      codeList = itemChild.code.split(',');
    } else if (itemChild.newChildren && itemChild.newChildren.length > 0) {
      listLength = getChildList(limit, itemChild).length;
    }
    if (itemChild.newChildren) {
      return codeList.every(cur => limit.includes(cur)) && listLength > 0;
    } else {
      return codeList.every(cur => limit.includes(cur));
    }
  });
  return childList;
};
// 循环遍历生成menulist
let getIds = (limit, menuList, arr = []) => {
  menuList.forEach(item => {
    if (!item.code && !item.newChildren) {
      arr.push(item);
    } else if (item.newChildren && item.newChildren.length > 0) {
      let childList = getChildList(limit, item);
      if (childList.length > 0) {
        item.children = [];
        arr.push(item);
        getIds(limit, item.newChildren, item.children);
      }
    } else {
      let codeList = [];
      if (item.code) {
        codeList = item.code.split(',');
      }
      let exit = codeList.every(cur => limit.includes(cur));
      if (exit) {
        arr.push(item);
      }
    }
  });
  return arr;
};
const actions = {
  addUserLimit({ dispatch, commit }) {
    commit('addUserLimit', { arr: userAuths });
    dispatch('buildMenu', userAuths);
  },
  addSearch({ dispatch, commit }, data) {
    commit('searchParam', { ...data });
  },
  addSearchDialog({ dispatch, commit }, data) {
    commit('searchParamDialog', { ...data });
  },
  clearPremission({ commit }) {
    commit('addMenu', { arr: [] });
  },
  buildMenu({ commit }, limit) {
    let userAuths = JSON.parse(localStorage.getItem('userAuths'));
    let arr = JSON.parse(localStorage.getItem('menuList')).children;
    commit('addMenu', { arr });
  },
  getArea({ commit }) {
    return new Promise((resolve, reject) => {
      let list = JSON.parse(localStorage.getItem('areaList'));
      if (list) {
        commit('areaList', list);
        resolve();
      }
      axios({
        url: '/basic/data/agent/getArea.htm',
        method: 'POST',
        data: {}
      }).then(res => {
        localStorage.setItem('areaList', JSON.stringify(res.data));
        commit('areaList', res.data);
        resolve();
      });
    });

  },
  computedTableHeight({ commit }, otherHeight) {
    let searchHeight = document.querySelector('.top-computed-ele') && document.querySelector('.top-computed-ele').clientHeight;
    let titleHeight = document.querySelector('.table-computed__ele') && document.querySelector('.table-computed__ele').clientHeight;
    let pageHeight = document.querySelector('.page-computed__ele') && document.querySelector('.page-computed__ele').clientHeight;
    let bodyHeight = document.querySelector('.body-content') && document.querySelector('.body-content').clientHeight;
    if (!bodyHeight) {
      bodyHeight = screen.height - 100;
    }
    let endHeight = bodyHeight;
    if (otherHeight) {
      otherHeight.forEach(item => {
        endHeight -= item;
      });
    } else {
      let baseHeight = 110;
      if (!searchHeight) {
        baseHeight = 90;
      }
      endHeight = endHeight - searchHeight - titleHeight - pageHeight - baseHeight + 40;
    }
    commit('setHeight', endHeight);
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js